import React, { useEffect, useState } from 'react';
import './FieldsetInput.scss';

export interface FieldsetInputProps {
  name?: string;
  label?: string;
  id: string;
  value: string | number;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  icon?: JSX.Element;
  validationMessage?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur?: () => void;
  handleIconClick?: () => void;
}

export const FieldsetInput = (props: FieldsetInputProps) => {
  const { id, onChange, icon, label, name, placeholder, type, handleIconClick, value, validationMessage, onBlur } =
    props;

  const [fieldsetInvalid, setFieldsetInvalid] = useState(false);

  useEffect(() => {
    setFieldsetInvalid(validationMessage ? true : false);
  }, [validationMessage]);

  return (
    <div className='fieldset-container'>
      <fieldset className={`fieldset ${fieldsetInvalid ? 'invalid' : ''}`}>
        {label ? (
          <legend>
            <label htmlFor={id}>{label}</label>
          </legend>
        ) : (
          <></>
        )}
        <input
          id={id}
          name={name}
          type={type ? type : 'text'}
          placeholder={placeholder}
          onChange={onChange}
          className='input'
          value={value || ''}
          onBlur={onBlur}
          data-testid={`input-${id}`}
        />
        {icon ? (
          <button type='button' className='icon-button' onClick={handleIconClick}>
            {icon}
          </button>
        ) : (
          <></>
        )}
      </fieldset>
      {validationMessage ? <p className='validation-message'>{validationMessage}</p> : <></>}
    </div>
  );
};
